import { Card, Col, Input, Row, Typography, Alert, Checkbox } from "antd";
import { SeoModel } from "shared/models/seo-model";

export interface ISeoProps {
  model: SeoModel;
  slug: string;
  onChange: (changedModel: SeoModel, newSlug: string) => void;
}

export function Seo(props: ISeoProps) {
  const { model, onChange, slug } = props;

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Card title="Meta Tag">
          <Input.Group className="mb-4">
            <Typography.Text>Title: </Typography.Text>
            {model?.metaTitle?.length > 55 && (
              <Alert
                message="Notification"
                description={`Title length should be less than 55 characters`}
                type="warning"
                showIcon
                className={`mb-2`}
                closable
              />
            )}
            <Input
              value={model.metaTitle}
              onChange={(e) => {
                onChange({ ...model, metaTitle: e.target.value }, slug);
              }}
              placeholder="Title"
            ></Input>
          </Input.Group>
          <Input.Group className="mb-4">
            <Typography.Text>Description: </Typography.Text>
            {model?.metaDescription?.length > 155 && (
              <Alert
                message="Notification"
                description={`Description length should be less than 155 characters`}
                type="warning"
                showIcon
                className={`mb-2`}
                closable
              />
            )}
            <Input.TextArea
              value={model.metaDescription}
              onChange={(e) => {
                onChange({ ...model, metaDescription: e.target.value }, slug);
              }}
              rows={5}
              placeholder="meta description"
            ></Input.TextArea>
          </Input.Group>
          <Input.Group className="mb-4">
            <Typography.Text>Keyword: </Typography.Text>
            <Input
              value={model.metaKeyword}
              onChange={(e) => {
                onChange({ ...model, metaKeyword: e.target.value }, slug);
              }}
              placeholder="Keyword"
            ></Input>
          </Input.Group>
          <Input.Group className="mb-4">
            <Typography.Text>Slug: </Typography.Text>
            <Input
              value={slug}
              placeholder="Slug"
              onChange={(e) => {
                onChange(model, e.target.value);
              }}
            ></Input>
          </Input.Group>
          <Input.Group className="mb-4">
              <Checkbox
                checked={model.excludeFromSitemap}
                onChange={(e) => {
                  onChange({ ...model,  excludeFromSitemap: e.target.checked }, slug);
                }}
              >
                Exclude FromSitemap
              </Checkbox>
            </Input.Group>
        </Card>
      </Col>
      <Col span={12}>
        <Card title="Extension">
          <Input.Group className="mb-4">
            <Typography.Text>Schema: </Typography.Text>
            <Input.TextArea
              value={model.schema}
              onChange={(e) => {
                onChange({ ...model, schema: e.target.value }, slug);
              }}
              rows={19}
              placeholder="Schema"
            ></Input.TextArea>
          </Input.Group>
        </Card>
      </Col>
    </Row>
  );
}
